










import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

@Component
export default class Beissbarth extends Vue {
  @Prop({ type: Object, required: true })
  public treadDepthReader: any

  @Prop({ type: Object, required: true })
  public rules: any
}
